export default "/fonts/RV-Harmonia-SemiBold.eot?bfdea6044135425273ec55472aed5c2b";